export default __webpack_public_path__ + "static/media/title_th_pc.7d682c27.png";